const replenP13nSelector = store => store.p13n?.replenData;

export { replenP13nSelector };
